import React from 'react';

// Libellés lisibles des plans payants
const PLAN_LABELS = {
  pro: 'Pro',
  premium: 'Premium',
  business: 'Business'
};

/**
 * Pastille d'abonnement unique pour la liste Clients.
 * Règle d'affichage (validée) :
 * - abonnement payant actif → le nom du plan (« Pro », « Premium », « Business »)
 *   (un plan payant affiché implique un abonnement actif) ;
 * - abonnement actif sans plan payant → « Actif » ;
 * - compte sans abonnement payant → « Free » ;
 * - plan payant non actif (expiré / suspendu) → « {Plan} · Inactif » (signal d'alerte).
 */
const SubscriptionBadge = ({ plan, subscriptionStatus }) => {
  const isPaid = Object.prototype.hasOwnProperty.call(PLAN_LABELS, plan);
  const isActive = subscriptionStatus === 'active';

  const paidStyles = {
    pro: 'bg-info/20 text-info border border-info/30',
    premium: 'bg-accent/20 text-accent border border-accent/30',
    business: 'bg-success/20 text-success border border-success/30'
  };

  let label;
  let style;
  if (isPaid) {
    label = PLAN_LABELS[plan];
    style = isActive ? paidStyles[plan] : 'bg-error/20 text-error border border-error/30';
    if (!isActive) label += ' · Inactif';
  } else if (isActive) {
    label = 'Actif';
    style = 'bg-success/20 text-success border border-success/30';
  } else {
    label = 'Free';
    style = 'bg-base-300 text-base-content border border-base-300';
  }

  return (
    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${style}`}>
      {label}
    </span>
  );
};

export default SubscriptionBadge;
